import React, {useState} from 'react';
import s from './BankTransfer.module.css'
import BankTransferStepOne from "./BankTransferStepOne/BankTransferStepOne";

type BankTransferPropsType = {
    isButtonDisable: boolean | undefined
}

const BankTransfer = (props: BankTransferPropsType) => {

    const [current, setCurrent] = useState(0);

    const steps = [
        {
            content: <BankTransferStepOne setCurrent={setCurrent}
                                          current={current}
                                          isButtonDisable={props.isButtonDisable}

            />
        },
    ];

    return (
        <>
            <div className={s.wrapper}>
                {steps[current].content}
            </div>
        </>
    );
};

export default BankTransfer;
